/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Funnel_Stage_AppliedInputs */

const en_analytics_funnel_stage_applied = /** @type {(inputs: Analytics_Funnel_Stage_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Applied`)
};

const de_analytics_funnel_stage_applied = /** @type {(inputs: Analytics_Funnel_Stage_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beworben`)
};

const fr_analytics_funnel_stage_applied = /** @type {(inputs: Analytics_Funnel_Stage_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postulé`)
};

const es_analytics_funnel_stage_applied = /** @type {(inputs: Analytics_Funnel_Stage_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Postulado`)
};

const it_analytics_funnel_stage_applied = /** @type {(inputs: Analytics_Funnel_Stage_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Candidata`)
};

const nl_analytics_funnel_stage_applied = /** @type {(inputs: Analytics_Funnel_Stage_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesolliciteerd`)
};

const pl_analytics_funnel_stage_applied = /** @type {(inputs: Analytics_Funnel_Stage_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wysłano`)
};

const fi_analytics_funnel_stage_applied = /** @type {(inputs: Analytics_Funnel_Stage_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haettu`)
};

const da_analytics_funnel_stage_applied = /** @type {(inputs: Analytics_Funnel_Stage_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgt`)
};

const sv_analytics_funnel_stage_applied = /** @type {(inputs: Analytics_Funnel_Stage_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansökt`)
};

/**
* | output |
* | --- |
* | "Applied" |
*
* @param {Analytics_Funnel_Stage_AppliedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_funnel_stage_applied = /** @type {((inputs?: Analytics_Funnel_Stage_AppliedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Funnel_Stage_AppliedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_funnel_stage_applied(inputs)
	if (locale === "fr") return fr_analytics_funnel_stage_applied(inputs)
	if (locale === "es") return es_analytics_funnel_stage_applied(inputs)
	if (locale === "it") return it_analytics_funnel_stage_applied(inputs)
	if (locale === "nl") return nl_analytics_funnel_stage_applied(inputs)
	if (locale === "pl") return pl_analytics_funnel_stage_applied(inputs)
	if (locale === "fi") return fi_analytics_funnel_stage_applied(inputs)
	if (locale === "da") return da_analytics_funnel_stage_applied(inputs)
	if (locale === "sv") return sv_analytics_funnel_stage_applied(inputs)
	return en_analytics_funnel_stage_applied(inputs)
});